import PropTypes from 'prop-types';
import useOnClickOutside from './use-click-outside';
/**
 * @param {Object} props props
 * @param {function} props.onclick outside handler
 * @param {object} props.targetRef parent ref
 * @returns {React.ReactComponent} HOC component for handling clicks outside
 */
export default function ClickOutside({ onClick, children, targetRef }) {
  useOnClickOutside(targetRef, onClick);
  return children;
}

ClickOutside.propTypes = {
  /** Event handler */
  onClick: PropTypes.func.isRequired,
  /** needs to be a React.createRef */
  targetRef: PropTypes.object.isRequired,
  /** remaining elements to render */
  children: PropTypes.node
};
